import { Component, Input, OnInit, inject, output, input, ChangeDetectionStrategy } from '@angular/core'; // ###
import { uploadOptionClass, UploadService } from '../../services/upload.service';
import { HttpClient } from '@angular/common/http';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { jkRestReturnClass } from '../../services/jkClass';

export type FileUploadMode = 'instantly' | 'useButtons' | 'useForm';
export type UploadHttpMethod = 'POST' | 'PUT';

// ng2-file-upload 或者 ngx-uploader。 TODO: 改用 ng2-file-upload 或者 ngx-uploader file-upload-with-preview FIXME:
/**
 * upload-file 較完整.考慮棄用此component
 */
@Component({
  selector: 'app-jkupload',
  templateUrl: './jkupload.component.html',
  styleUrls: ['./jkupload.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [], // DxFileUploaderModule
})
export class JkuploadComponent extends JkBaseComponent implements OnInit {
  upload = inject(UploadService);

  override comType: string = 'jkupload';
  _accept: string = '*';
  fileObj!: File;

  readonly enabled = input(true);
  readonly value = input<File[]>([]);// 這裡不要再改了
  readonly valueChange = output<any>();
  onValueChange(newValue: any) {
    this.valueChange.emit(newValue);
  }

  readonly uploadChange = input.required<(e: any) => void>();

  readonly programId = input<string>('upload');
  readonly selectButtonText = input<string>('選擇檔案');
  readonly labelText = input<string>('拖曳檔案到此處或點擊上方按鈕');
  readonly uploadUrl = input<string>('http://localhost:3000/upload');
  //@Input() uploadFiles: any[] = []; // File[] = [];
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() allowedFileExtensions: string[] = [];
  readonly minFileSize = input<number>(0);
  readonly maxFileSize = input<number>(1000000);
  @Input() uploadFile: any = (e: any) => {
    //console.log('uploadChange', e);
    const uploadChange = this.uploadChange();
    if (uploadChange) {
      uploadChange(e);
    } else {
      this.fileUploader_uploadFile(e, null);
    }
  };
  readonly multiple = input(false);
  readonly uploadMode = input<FileUploadMode>('useButtons'); // useButtons, useForm, instantly
  readonly uploadMethod = input<UploadHttpMethod>('POST');
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  get accept(): string {
    return this._accept;
  };
  set accept(value: string) {
    this._accept = value;
    if (this.allowedFileExtensions.length > 0) {
      return;
    }
    if (value === '*') {
      this.allowedFileExtensions = [];
    }
    if (value === 'image/*') {
      this.allowedFileExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
    }
    if (value === 'video/*') {
      this.allowedFileExtensions = ['.mp4', '.avi', '.mov', '.mkv'];
    }
    if (value === 'audio/*') {
      this.allowedFileExtensions = ['.mp3', '.wav', '.ogg', 'm4a'];
    }
    if (value === 'application/*') {
      this.allowedFileExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt'];
    }
    if (value === 'application/pdf') {
      this.allowedFileExtensions = ['.pdf'];
    }

  };

  override ngOnInit() {
    super.ngOnInit();
  }

  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    let uploadOpt = new uploadOptionClass();
    uploadOpt.uploadUrl = this.uploadUrl(); // Login.hostName+'/api/upload_devextreme';
    //this.upload.init(this.uploadCom,this.uid,this.programId,uploadOpt);
    //this.uploadMask.init(this.uploadMaskCom,this.uid,this.programId,uploadOpt);
  }
  getFileName(): string {
    let result = '';
    let n = this.value().length;
    if (n === 0) return '';
    for (let i = 0; i < n; i++) {
      if (i > 0) result += ',';
      result += this.value()[i].name;
    }
    return result;
  }

  async fileUploader_uploadFile(xfile: File, progressCallback: any) {
    if (!xfile) return;
    //let n = this.uploadFiles.length;
    //if(n===0) return;

    // your code
    if (progressCallback)
      progressCallback(100);
    // ...
    if (progressCallback)
      progressCallback(200);
    // ...
    /*if (n > 0) {
      this.fileObj = this.uploadFiles[0];
    } else {
      alert('請選擇檔案');
      return;
    }*/
    this.fileObj = xfile;
    if (this.fileObj) {
      if (this.fileObj.size > this.maxFileSize()) {
        alert('檔案大小超過限制');
        return;
      }
      let formData = new FormData();

      formData.append('fileupload', this.fileObj);
      formData.append('filename', this.fileObj.name);
      formData.append('userid', this.uid);
      formData.append('programid', this.programId());
      /*const httpOptions = {
        headers: new HttpHeaders({
        'Content-Type': 'application/json'
        })
       };*/
      let upload$ = this.http.post<jkRestReturnClass>(this.uploadUrl(), formData);
      upload$.subscribe();// 到底要如何等待回傳值呢?
    }
  }



}
